import React from "react";

const EmailNotificationCard = ({
  notificationEmails,
  newEmail,
  setNewEmail,
  emailLoading,
  addNotificationEmail,
  removeNotificationEmail
}) => {
  return (
    <div className="details-card">
      <div className="details-card-header">
        <span>
          <i className="bi bi-envelope me-2"></i> Lead Notification Emails
        </span>
      </div>
      <div className="details-card-body">
        <div className="alert alert-light border mb-4">
          <small className="text-muted">
            <i className="bi bi-info-circle me-1"></i> All leads are automatically sent to{" "}
            <strong>web.developer@kaycomm.in</strong>. Add extra emails below.
          </small>
        </div>

        <div className="input-group mb-4" style={{ maxWidth: "500px" }}>
          <input
            type="email"
            className="form-control"
            placeholder="Enter email address"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && addNotificationEmail()}
            disabled={emailLoading}
          />
          <button
            className="btn btn-primary"
            onClick={addNotificationEmail}
            disabled={emailLoading || !newEmail}
          >
            {emailLoading ? "Adding..." : "Add Email"}
          </button>
        </div>

        {notificationEmails.length > 0 ? (
          <div className="d-flex flex-column gap-2">
            {notificationEmails.map((email, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center bg-light p-3 rounded border"
              >
                <span className="fw-medium">{email}</span>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => removeNotificationEmail(email)}
                  disabled={emailLoading}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-muted fst-italic">
            No additional notification emails configured.
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailNotificationCard;
